import { render, staticRenderFns } from "./PaymentCreate.vue?vue&type=template&id=6ca5e330"
import script from "../../../controllers/custom/payment/payment-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/payment/payment-create.js?vue&type=script&lang=js&external"
import style0 from "./PaymentCreate.vue?vue&type=style&index=0&id=6ca5e330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports